<div class="row justify-content-between gy-3">
  <div [class]="'col-12 col-md-6 ' + (isSingleSiteSelectMode ? 'single-control-container' : 'double-control-container')">
    <label for="pageSiteDateSites" class="form-label">{{'Site' | messageTranslate}}</label>
    <app-site-select-with-single-and-multi
      id="pageSiteDateSites"
      [formControl]="formGroup.controls.siteSelection"
      [multiSelect]="multiSelect"
      (sitesLoaded)="onSitesLoaded($event)"
      (clientsLoaded)="onClientsLoaded($event)"/>
  </div>
  @if (middleContent) {
    <div class="order-3 order-xl-0 col-auto ms-auto">
      <div class="form-label d-none d-xl-block">&nbsp;</div>
      <ng-content></ng-content>
    </div>
  }
  <div class="col-12 col-md-6 single-control-container">
    <label for="pageSiteDatePicker" class="form-label">{{'Date range' | messageTranslate}}</label>
    <app-date-time-range-picker
      id="pageSiteDatePicker"
      [mode]="pickerMode"
      [formControl]="formGroup.controls.dateRange"
      [label]="dateRangeLabels"
      [showIncludeToday]="showIncludeToday"
      [relativeDateRanges]="relativeDateRanges" />
  </div>
</div>
